import axios from "../javascript/custom-axios";
const V1 = "/v1";
const RESOURCE_NAME_USER = "/users";
const RESOURCE_NAME = "/posts";
const RESOURCE_NAME_TAGS = "/tags";
const RESOURCE_NAME_UPLOAD = "/upload";
const RESOURCE_NAME_CHAT = "/chat";

export default {
  getContent(key, Page, PageSize, flag = false, Search = "", ids) {
    let url = "";
    if (flag) {
      if (typeof ids === "object") {
        let str = "";
        ids.map((i) => {
          str += `&CategoryIds=${i}`;
        });
        url =
          `${V1}${RESOURCE_NAME_USER}${RESOURCE_NAME}?key=${key}&Page=${Page}&PageSize=${PageSize}` +
          str;
      } else {
        url = `${V1}${RESOURCE_NAME_USER}${RESOURCE_NAME}?key=${key}&CategoryIds=${ids}&Page=${Page}&PageSize=${PageSize}&Search=${Search}`;
      }
    } else {
      url = `${V1}${RESOURCE_NAME_USER}/posts?key=${key}&Page=${Page}&PageSize=${PageSize}&Search=${Search}`;
    }
    return axios.get(url);
  },

  getBornToday(Page, PageSize) {
    return axios.get(`${V1}${RESOURCE_NAME_USER}/borntoday`);
  },

  getBestOf(type = "post") {
    return axios.get(`${V1}${RESOURCE_NAME_USER}/topfive?type=` + type);
  },

  getWhosWho(search = "", page = 1, pageSize = 100) {
    return axios.get(`${V1}${RESOURCE_NAME_USER}/whoswho?search=${search}`);
  },

  getTags() {
    return axios.get(`${V1}${RESOURCE_NAME_TAGS}/tagList`);
  },

  getProfilePost(id, page = 1, pageSize = 10, type = "individual") {
    return axios.get(
      `${V1}${RESOURCE_NAME}?UserId=${id}&type=${type}&page=${page}&pageSize=${pageSize}`
    );
  },

  uploadFile(body) {
    return axios.post(`${V1}${RESOURCE_NAME_UPLOAD}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  createChatRoom(body) {
    const url = `${V1}${RESOURCE_NAME_CHAT}/ChatGroup`;
    return axios.post(url, body);
  },
};
